module.exports = "/_next/static/images/Hero@2x-6db62c3aa64ae85736b7a0c22a981b32.webp";